module.exports = __webpack_public_path__ + "img/calendar-blue.51b780cd.svg";